import type { ChatFocusRef } from '@/stores/chatbot'

/**
 * What the assistant is pointed at when someone asks about a document the chat
 * wrote (MYAC-1162).
 *
 * `uid` is the doc_id — the identifier the agent's `read_authored_document`
 * takes. The title travels twice on purpose: `name` is how the agent may refer
 * to it, `label` is what the attachment chip shows the user.
 *
 * **The untitled fallback lives here, not in the callers.** It was in the row
 * only, and the document page shipped without it for one round: an untitled
 * document then attached with an empty label, and `focusChipLabel` falls through
 * label → name → code → uid, so the chip showed the user a raw `doc_id`. Taking
 * the label as a required argument and applying the fallback here is the whole
 * point of a shared builder — the two callers cannot drift again.
 */
export function authoredDocumentFocus(
  docId: string,
  title: string | undefined,
  untitledLabel: string,
): ChatFocusRef {
  const name = title?.trim() || untitledLabel
  return { kind: 'authored_document', uid: docId, name, label: name }
}
